import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://api.botanix.in/api';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#0F2040',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#22C55E', red:'#EF4444', redBg:'rgba(239,68,68,.1)',
 amber:'#F59E0B', amberBg:'rgba(245,158,11,.1)',
};

const STAFF_MEALS = {
 Breakfast: ['Poha','Upma','Bread Butter','Tea','Chai','Juice','Paratha','Boiled Eggs'],
 Lunch: ['Dal','Sabzi','Rice','Roti','Salad','Papad','Chaas'],
 Dinner: ['Dal','Sabzi','Rice','Roti','Salad','Sweet Dish'],
 Snacks: ['Tea','Coffee','Biscuits','Bread','Namkeen'],
};

const DEPTS = ['All','Front Office','Kitchen','Housekeeping','Accounts','Sales','Activities','Security','Driver','Management'];

const inp = { width:'100%', padding:'10px 12px', background:'rgba(255,255,255,.05)', border:`1px solid rgba(30,58,95,1)`, borderRadius:8, color:'#F0F2FF', fontSize:13, boxSizing:'border-box', outline:'none', fontFamily:'Inter,sans-serif' };
const sel = { ...inp, cursor:'pointer' };

const todayStr = new Date().toISOString().slice(0,10);

export default function StaffFood() {
 const [date, setDate] = useState(todayStr);
 const [saving, setSaving] = useState(false);
 const [success, setSuccess] = useState('');
 const [history, setHistory] = useState([]);

 const [meals, setMeals] = useState({
 Breakfast: { enabled:true, pax:15, items:['Poha','Tea','Bread Butter'], dept:'All', time:'07:30' },
 Lunch: { enabled:true, pax:20, items:['Dal','Sabzi','Rice','Roti'], dept:'All', time:'13:00' },
 Snacks: { enabled:true, pax:15, items:['Tea','Biscuits'], dept:'All', time:'16:30' },
 Dinner: { enabled:true, pax:20, items:['Dal','Sabzi','Rice','Roti'], dept:'All', time:'20:00' },
 });

 const toggleItem = (meal, item) => {
 setMeals(p=>({...p,[meal]:{...p[meal],items:p[meal].items.includes(item)?p[meal].items.filter(i=>i!==item):[...p[meal].items,item]}}));
 };

 const handleSave = async () => {
 setSaving(true);
 try {
 // Save as a kitchen order note
 const payload = {
 date, meals,
 total_pax: Math.max(...Object.values(meals).filter(m=>m.enabled).map(m=>m.pax)),
 saved_by: JSON.parse(localStorage.getItem('botanix_user')||'{}')?.name,
 saved_at: new Date().toISOString(),
 };
 // Store via bookings note or kitchen API
 await fetch(`${API}/kitchen/staff-food`, {
 method:'POST', headers:{'Content-Type':'application/json'},
 body: JSON.stringify(payload),
 }).catch(()=>{});
 setHistory(p=>[{...payload, id:Date.now()}, ...p].slice(0,7));
 setSuccess('Staff food plan saved! Kitchen notified. ');
 setTimeout(()=>setSuccess(''),3000);
 } catch(e) {}
 finally { setSaving(false); }
 };

 return (
 <div style={{ padding:24, background:C.bg, minHeight:'100vh', color:C.text, fontFamily:'Inter,sans-serif' }}>
 <div style={{ maxWidth:900, margin:'0 auto' }}>

 {/* Header */}
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
 <div>
 <div style={{ fontSize:22, fontWeight:800 }}> Daily Staff Food Plan</div>
 <div style={{ fontSize:13, color:C.text2, marginTop:2 }}>Set daily meals for staff — linked to Kitchen & GM Dashboard</div>
 </div>
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 <input type="date" value={date} onChange={e=>setDate(e.target.value)}
 style={{ ...inp, width:160 }} />
 <button onClick={handleSave} disabled={saving}
 style={{ padding:'10px 20px', background:C.accent, border:'none', borderRadius:8, color:'#fff', cursor:'pointer', fontSize:13, fontWeight:700, opacity:saving?.6:1 }}>
 {saving?'Saving…':' Save & Notify Kitchen'}
 </button>
 </div>
 </div>

 {success && <div style={{ padding:'10px 14px', background:'rgba(34,197,94,.1)', border:'1px solid rgba(34,197,94,.3)', borderRadius:8, color:C.accent, fontSize:13, marginBottom:16 }}>{success}</div>}

 {/* Meal cards */}
 <div style={{ display:'grid', gap:14 }}>
 {Object.entries(STAFF_MEALS).map(([meal, allItems])=>{
 const m = meals[meal] || { enabled:false, pax:15, items:[], dept:'All', time:'' };
 return (
 <div key={meal} style={{ background:C.surface, border:`1px solid ${m.enabled?C.accent:C.border}`, borderRadius:14, padding:18 }}>
 <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:m.enabled?16:0 }}>
 <div style={{ display:'flex', alignItems:'center', gap:10 }}>
 <input type="checkbox" checked={!!m.enabled}
 onChange={e=>setMeals(p=>({...p,[meal]:{...p[meal],enabled:e.target.checked}}))}
 style={{ width:18, height:18, cursor:'pointer' }} />
 <div style={{ fontWeight:700, fontSize:15, color:m.enabled?C.accent:C.text }}>{meal}</div>
 </div>
 {m.enabled && (
 <div style={{ display:'flex', gap:10, alignItems:'center' }}>
 <div>
 <span style={{ fontSize:11, color:C.text3 }}>Time: </span>
 <input type="time" value={m.time}
 onChange={e=>setMeals(p=>({...p,[meal]:{...p[meal],time:e.target.value}}))}
 style={{ ...inp, width:100, padding:'4px 8px', display:'inline-block' }} />
 </div>
 <div>
 <span style={{ fontSize:11, color:C.text3 }}>Pax: </span>
 <input type="number" value={m.pax}
 onChange={e=>setMeals(p=>({...p,[meal]:{...p[meal],pax:parseInt(e.target.value)||0}}))}
 style={{ ...inp, width:70, padding:'4px 8px', display:'inline-block' }} />
 </div>
 <div>
 <span style={{ fontSize:11, color:C.text3 }}>Dept: </span>
 <select value={m.dept}
 onChange={e=>setMeals(p=>({...p,[meal]:{...p[meal],dept:e.target.value}}))}
 style={{ ...sel, width:130, padding:'4px 8px', display:'inline-block' }}>
 {DEPTS.map(d=><option style={{background:'#0F2040',color:'#F0F2FF'}} key={d}>{d}</option>)}
 </select>
 </div>
 </div>
 )}
 </div>
 {m.enabled && (
 <div>
 <div style={{ fontSize:11, color:C.text3, marginBottom:8, textTransform:'uppercase', letterSpacing:'.05em' }}>Select Menu Items</div>
 <div style={{ display:'flex', flexWrap:'wrap', gap:6 }}>
 {allItems.map(item=>(
 <span key={item} onClick={()=>toggleItem(meal,item)}
 style={{ padding:'5px 12px', borderRadius:20, fontSize:12, cursor:'pointer', fontWeight:500,
 background:m.items.includes(item)?C.accent:'rgba(255,255,255,.06)',
 color:m.items.includes(item)?'#fff':C.text2,
 border:`1px solid ${m.items.includes(item)?C.accent:C.border}` }}>
 {item}
 </span>
 ))}
 </div>
 {m.items.length>0 && (
 <div style={{ marginTop:10, fontSize:12, color:C.accent }}>
 Selected: {m.items.join(', ')}
 </div>
 )}
 </div>
 )}
 </div>
 );
 })}
 </div>

 {/* Summary */}
 <div style={{ marginTop:20, background:C.surface, border:`1px solid ${C.border}`, borderRadius:14, padding:18 }}>
 <div style={{ fontWeight:700, fontSize:15, color:C.text, marginBottom:14 }}> Today's Staff Food Summary</div>
 <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:10 }}>
 {Object.entries(meals).filter(([,m])=>m.enabled).map(([meal,m])=>(
 <div key={meal} style={{ background:`${C.accent}10`, border:`1px solid ${C.accent}33`, borderRadius:10, padding:12 }}>
 <div style={{ fontWeight:700, color:C.accent, fontSize:13 }}>{meal}</div>
 <div style={{ fontSize:11, color:C.text2, marginTop:4 }}>{m.time} · {m.pax} pax · {m.dept}</div>
 <div style={{ fontSize:11, color:C.text3, marginTop:4 }}>{m.items.join(', ')||'No items selected'}</div>
 </div>
 ))}
 </div>
 </div>

 </div>
 </div>
 );
}
